import { render } from "./KubernetesStorage.vue?vue&type=template&id=db8037ac"
import script from "./KubernetesStorage.vue?vue&type=script&lang=js"
export * from "./KubernetesStorage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__